import { graphql, useLazyLoadQuery } from "react-relay";
import { FantasyArticlesHeader } from "../__pages/Articles/BettingArticles/styles";

const GET_WHO_AM_I = graphql`
  query WhoAmIQuery {
    whoAmI {
      groups {
        name
      }
    }
  }
`;

export default function WhoAmI(props) {
  const data = useLazyLoadQuery(GET_WHO_AM_I);

  return data.whoAmI &&
    data.whoAmI.groups.find((g) => g.name === props.groupName)
    ? props.children
    : null;
}
